import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  SagaIterator,
  assertPartialSchema,
  call,
} from '../../lib'
import {insertGarminConnectDataToDailyDb} from '../db/db_data_setter'
import {
  doREQUEST_ERROR,
  doREQUEST_COMPLETE,
  doHANDLE_PARTICIPANT_DAILY_DATA_DB_RESULT,
  doPENDING_REQUEST_DELETE,
  doREQUEST_SKIP,
} from '../state'
import {checkRequestPending} from './check_pending_request'
import {getToken} from './token_fetcher'

export const REQUEST_VISUALIZER_DAILY_SUMMARY_DATA_FETCH = 'REQUEST_VISUALIZER_DAILY_SUMMARY_DATA_FETCH'
export const doREQUEST_VISUALIZER_DAILY_SUMMARY_DATA_FETCH = createDoRequestAction(
  REQUEST_VISUALIZER_DAILY_SUMMARY_DATA_FETCH,
)

export const requestVisualizerDailySummaryDataFetchActionCreators = {
  doREQUEST_VISUALIZER_DAILY_SUMMARY_DATA_FETCH,
}

export function* requestVisualizerDailySummaryDataFetch({payload, setRequestResult}: any): SagaIterator {
  debug('saga*requestVisualizerDailySummaryDataFetch')

  const sameRequestPending = yield call(checkRequestPending, REQUEST_VISUALIZER_DAILY_SUMMARY_DATA_FETCH, payload)
  if (sameRequestPending === true) {
    return yield put(
      doREQUEST_SKIP({
        fromType: REQUEST_VISUALIZER_DAILY_SUMMARY_DATA_FETCH,
        requestId: payload.requestId,
      }),
    )
  }

  let didPendingRequestDelete = false
  try {
    try {
      assertPartialSchema({
        payload,
        schema: v.object({
          participantId: v.string().uuid().required(),
          yymmddIndexStart: v.number().required().example(231011),
          yymmddIndexEnd: v.number().required().example(231111),
          dataType: v.string().required(),
          projection: v.object().optional().allow(null),
        }),
      })
    } catch (error) {
      yield put(
        doPENDING_REQUEST_DELETE({
          requestType: REQUEST_VISUALIZER_DAILY_SUMMARY_DATA_FETCH,
          requestId: payload.requestId,
        }),
      )
      didPendingRequestDelete = true
      return yield put(
        doREQUEST_ERROR(
          {
            fromType: REQUEST_VISUALIZER_DAILY_SUMMARY_DATA_FETCH,
            requestId: payload.requestId,
            error,
          },
          setRequestResult,
        ),
      )
    }

    const {participantId, yymmddIndexStart, yymmddIndexEnd, dataType, projection} = payload

    const accessToken = yield call(getToken)

    const result = yield request({
      method: 'post',
      url: `${API_URL}/v1/web/visualizer-daily-summary-data-fetch`,
      accessToken,
      data: {
        participantId,
        yymmddIndexStart,
        yymmddIndexEnd,
        dataTypeList: [dataType],
        projection,
      },
    })

    if (!result.success || result.error) {
      const error = result.error || new Error('request did not succeed')
      debug(error)
      yield put(
        doPENDING_REQUEST_DELETE({
          requestType: REQUEST_VISUALIZER_DAILY_SUMMARY_DATA_FETCH,
          requestId: payload.requestId,
        }),
      )
      didPendingRequestDelete = true
      return yield put(
        doREQUEST_ERROR(
          {
            fromType: REQUEST_VISUALIZER_DAILY_SUMMARY_DATA_FETCH,
            fromPayload: payload,
            requestId: payload.requestId,
            url: '/v1/web/visualizer-daily-summary-data-fetch',
            ...result,
            error,
          },
          setRequestResult,
        ),
      )
    } else {
      const dbOperationResultList = yield call(async () => {
        return await insertGarminConnectDataToDailyDb(
          participantId,
          [yymmddIndexStart, yymmddIndexEnd],
          dataType,
          result.payload,
        )
      })

      yield put(
        doHANDLE_PARTICIPANT_DAILY_DATA_DB_RESULT({
          dbOperationResultList,
        }),
      )
    }

    yield put(
      doPENDING_REQUEST_DELETE({
        requestType: REQUEST_VISUALIZER_DAILY_SUMMARY_DATA_FETCH,
        requestId: payload.requestId,
      }),
    )
    didPendingRequestDelete = true

    yield put(
      doREQUEST_COMPLETE(
        {
          fromType: REQUEST_VISUALIZER_DAILY_SUMMARY_DATA_FETCH,
          requestId: payload.requestId,
          ...result.payload,
        },
        setRequestResult,
      ),
    )
  } catch (error) {
    debug(error)
    yield put(
      doPENDING_REQUEST_DELETE({
        requestType: REQUEST_VISUALIZER_DAILY_SUMMARY_DATA_FETCH,
        requestId: payload?.requestId,
      }),
    )
    didPendingRequestDelete = true
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_VISUALIZER_DAILY_SUMMARY_DATA_FETCH,
          fromPayload: payload,
          requestId: payload?.requestId,
          url: '/v1/web/visualizer-daily-summary-data-fetch',
          error,
        },
        setRequestResult,
      ),
    )
  } finally {
    if (!didPendingRequestDelete) {
      yield put(
        doPENDING_REQUEST_DELETE({
          requestType: REQUEST_VISUALIZER_DAILY_SUMMARY_DATA_FETCH,
          requestId: payload?.requestId,
        }),
      )
    }
  }
}

export function* visualizerDailySummaryDataFetchSaga() {
  yield takeEvery(REQUEST_VISUALIZER_DAILY_SUMMARY_DATA_FETCH, requestVisualizerDailySummaryDataFetch)
}
